import { apiRequest } from './client';

/** Admin subscription plan catalogue. */
const TOKEN_KEY = 'policyora_token';
const opts = (extra: RequestInit = {}): RequestInit => {
  const token = localStorage.getItem(TOKEN_KEY);
  return { ...extra, headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}), ...(extra.headers || {}) } };
};

export type Segment = 'standard' | 'free' | 'law_firm' | 'government' | 'enterprise';
export type Quantity = number | 'unlimited';
export interface PlanFeatureSet {
  user_seats: Quantity; jurisdictions: Quantity; ai_summaries_per_month: Quantity; documents_per_month: Quantity; custom_alerts: Quantity; ai_agents: Quantity; policies_per_month: Quantity;
  multi_jurisdiction: boolean; api_access: boolean; team_collaboration: boolean; export_reporting: boolean; sso: boolean;
  dedicated_support: boolean; advanced_ai: boolean; predictive_analytics: boolean; legal_matters: boolean; white_label: boolean;
}
export interface CatalogPlan {
  tier: string; display_name: string; description: string; segment: Segment;
  monthly_price_usd: string | number | null; annual_price_usd: string | number | null;
  is_popular: boolean; contact_sales: boolean; show_on_pricing: boolean; sort_order: number; disabled: boolean;
  features: PlanFeatureSet; updated_by: string | null; updated_at: string | null; subscribers?: number;
}
export interface CatalogView { plans: CatalogPlan[]; segments: Segment[]; bool_features: (keyof PlanFeatureSet)[]; quantities: (keyof PlanFeatureSet)[] }

export const adminListPlans = () => apiRequest<CatalogView>('/api/v1/admin/plans', opts());
export const adminCreatePlan = (p: Partial<CatalogPlan> & { tier: string; display_name: string }) => apiRequest<CatalogPlan>('/api/v1/admin/plans', opts({ method: 'POST', body: JSON.stringify(p) }));
export const adminUpdatePlan = (tier: string, p: Partial<CatalogPlan>) => apiRequest<CatalogPlan>(`/api/v1/admin/plans/${encodeURIComponent(tier)}`, opts({ method: 'PUT', body: JSON.stringify(p) }));
export const adminDeletePlan = (tier: string) => apiRequest<{ deleted: string }>(`/api/v1/admin/plans/${encodeURIComponent(tier)}`, opts({ method: 'DELETE' }));
